import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export default function Floater({
                                  anchorRef,
                                  anchorId,
                                  children,
                                  offsetX = 0,
                                  offsetY = 0,
                                }) {
  const floaterRef = useRef(null);
  const [position, setPosition] = useState({ top: -9999, left: -9999 });

  useEffect(() => {
    let animationFrameId = null;

    function updatePosition() {
      let anchorEl = anchorRef?.current || null;
      if (!anchorEl && anchorId) {
        anchorEl = document.getElementById(anchorId);
      }
      if (!anchorEl || !floaterRef.current) return;

      const anchorRect = anchorEl.getBoundingClientRect();
      const floaterRect = floaterRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      let newLeft = anchorRect.left + offsetX;
      let newTop = anchorRect.top + offsetY;

      // ⬅ Push left if overflowing right
      if (newLeft + floaterRect.width > viewportWidth) {
        newLeft = viewportWidth - floaterRect.width;
      }

      // ⬆ Push up if overflowing bottom
      if (newTop + floaterRect.height > viewportHeight) {
        newTop = viewportHeight - floaterRect.height;
      }

      // Clamp to min 0 to avoid negative positioning
      newLeft = Math.max(0, newLeft);
      newTop = Math.max(0, newTop);

      setPosition((prev) => {
        if (prev.top !== newTop || prev.left !== newLeft) {
          return { top: newTop, left: newLeft };
        }
        return prev;
      });

      animationFrameId = requestAnimationFrame(updatePosition);
    }

    animationFrameId = requestAnimationFrame(updatePosition);
    return () => cancelAnimationFrame(animationFrameId);
  }, [anchorRef, anchorId, offsetX, offsetY]);

  return createPortal(
    <div
      ref={floaterRef}
      style={{
        position: "fixed",
        top: position.top,
        left: position.left,
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      {children}
    </div>,
    document.body
  );
}
